// extracted by mini-css-extract-plugin
export default {"label":"form_label__YuMET","input":"form_input__uqfn-"};